export type SessionVisibility = "private" | "shared";
export type AccessMode = "invite_only" | "organization";
export type SpaceRole = "owner" | "editor";

export interface SpaceSummary {
  id: string;
  name: string;
  description: string;
  session_visibility: SessionVisibility;
  access_mode: AccessMode;
  role: SpaceRole | null;
  member_count: number;
  created_at: string | null;
  updated_at: string | null;
}

export interface SpaceMember {
  user_id: string;
  email: string;
  name: string;
  role: SpaceRole;
  joined_at: string | null;
}

export interface SpaceDetail extends SpaceSummary {
  members: SpaceMember[];
}

export interface SpaceInvite {
  token: string;
  space_id: string;
  role: SpaceRole;
  expires_at: string | null;
  max_uses: number | null;
  uses: number;
  revoked_at: string | null;
  created_at: string | null;
}

/**
 * UI-level "type" of a space, derived from server fields rather than
 * stored — keeps the source of truth in the DB to two booleans
 * (visibility + access_mode) and lets the UI label them however it
 * wants without a third state to keep in sync.
 */
export type SpaceUiType = "personal" | "team_private" | "team_shared" | "public";

export function deriveUiType(s: Pick<SpaceSummary, "session_visibility" | "access_mode" | "member_count">): SpaceUiType {
  if (s.access_mode === "organization") return "public";
  if (s.session_visibility === "shared") return "team_shared";
  if (s.member_count > 1) return "team_private";
  return "personal";
}

export const UI_TYPE_LABEL: Record<SpaceUiType, string> = {
  personal: "Личное",
  team_private: "Командное приватное",
  team_shared: "Командное общее",
  public: "Публичное",
};
